import { Icon, Table, Text } from '@quintoandar-tokko/jopijs';
import styles from '../dashboardTables.module.scss';
import PropertyOrDevelopmentCell from '../components/PropertyOrDevelopmentCell';
import ContactCell from '../components/ContactCell';
import AgentBranchCell from '../components/AgentBranchCell';

export default function PropertyConsultationsTableRow({ row }) {
  const {
    property_type,
    inquiry,
    producer,
    owner,
    operation,
    property,
    id,
    value,
  } = row;

  return (
    <Table.RowDefault id={id} variant="secondary">
      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <PropertyOrDevelopmentCell
          id={property?.id}
          thumbnail={property?.thumbnail}
          address={property?.address}
          location={property?.location}
          modal="propertyConsultations"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        {operation ? (
          <Text variant="body.fontSize13">{operation}</Text>
        ) : (
          <Icon icon="icon-mostrarmenos" className={styles.emptyDataIcon} />
        )}
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        {property_type ? (
          <Text variant="body.fontSize13">{property_type}</Text>
        ) : (
          <Icon icon="icon-mostrarmenos" className={styles.emptyDataIcon} />
        )}
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        {value?.value ? (
          <Text variant="body.fontSize13">{`${value?.currency} ${value?.value}`}</Text>
        ) : (
          <Icon icon="icon-mostrarmenos" className={styles.emptyDataIcon} />
        )}
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <ContactCell
          highlighted={false}
          id={owner?.id}
          cellphone={owner?.cellphone}
          name={owner?.name}
          email={owner?.email}
          image={owner?.profile_picture}
          leadStatus={owner?.lead_status}
          agent={producer}
          relativeSelector="#property-consultations-modal"
          modal="propertyConsultations"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <AgentBranchCell
          agentId={producer?.id}
          agentName={producer?.name}
          branchName={producer?.branch_name}
          image={producer?.profile_picture}
          relativeSelector="#property-consultations-modal"
          modal="propertyConsultations"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13" className={styles.textToRight}>
          {inquiry}
        </Text>
      </Table.RowItemDefault>
    </Table.RowDefault>
  );
}
